import { Controller } from "@hotwired/stimulus"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="textarea"
export default class extends Controller {
  static targets = ["textarea"]

  static values = {
    newlines: { type: Boolean, default: true }
  }

  connect() {
    this.debug("Connect")

    this.textareaTarget.addEventListener("focus", this.onFocus)
    this.textareaTarget.addEventListener("blur", this.onBlur)

    if (!this.newlinesValue) {
      this.textareaTarget.addEventListener("keydown", this.preventNewline)
      this.textareaTarget.addEventListener("input", this.stripNewlines)
    }

    this.textareaTarget.addEventListener("input", this.resize)
  }

  disconnect() {
    this.debug("Disconnect")

    this.textareaTarget.removeEventListener("focus", this.onFocus)
    this.textareaTarget.removeEventListener("blur", this.onBlur)

    if (!this.newlinesValue) {
      this.textareaTarget.removeEventListener("keydown", this.preventNewline)
      this.textareaTarget.removeEventListener("input", this.stripNewlines)
    }

    this.textareaTarget.removeEventListener("input", this.resize)
  }

  resize = () => {
    this.debug("Resizing textarea", { id: this.textareaTarget.id })

    this.element.dataset.text = this.textareaTarget.value
  }

  preventNewline = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  stripNewlines = () => {
    const textarea = this.textareaTarget
    const value = textarea.value

    if (value.includes("\n") || value.includes("\r")) {
      const position = textarea.selectionStart
      const cleaned = value.replace(/[\r\n]+/g, " ")
      const positionAdjustment = value.length - cleaned.length

      textarea.value = cleaned
      textarea.selectionStart = position - positionAdjustment
      textarea.selectionEnd = position - positionAdjustment
    }
  }

  onFocus = () => {
    morphdomIgnore(this.element, true)
  }

  onBlur = () => {
    morphdomIgnore(this.element, false)
  }

  debug(message, data) {
    Log.debug("Textarea - " + message, data)
  }
}
